module.exports = __webpack_public_path__ + "img/sbzc_16.0fd25f10.jpg";